import React, { FC } from 'react';
import { NamePath } from 'antd/lib/form/interface';

import { useBusinessDocumentTypePageNames } from '~/hooks/useHandbook';
import { Form } from '~/components';
import ImageInput from './ImageInput';

interface Props {
  name?: NamePath;
  nameFn?: (name: string | number) => NamePath;
  countryId: string | undefined;
  legalType: string | undefined;
  documentType: string | undefined;
}

const BusinessDocumentPagesInputGroup: FC<Props> = (props) => {
  const { nameFn, name = 'files', countryId, legalType, documentType } = props;
  const { options } = useBusinessDocumentTypePageNames({ countryId, legalType, documentType });
  return (
    <>
      {options.map(({ label, value }, index) => {
        return (
          <Form.Item
            key={value}
            name={nameFn ? nameFn(index) : ([name, index] as NamePath)}
            rules={[{ required: true }]}
          >
            <ImageInput label={label} name={value} multiple={false} accept="image/*,.pdf" />
          </Form.Item>
        );
      })}
    </>
  );
};

export default BusinessDocumentPagesInputGroup;
